<script>
  import CustomizerModal from "./CustomizerModal.svelte";
  import GradientPreviewModal from "./GradientPreviewModal.svelte";
  export let gradientStyle;
</script>

<div class="gradient-container">
  <div class="bg-gradient" style={gradientStyle} />
  <p class="gradient-style-text">{gradientStyle}</p>
  <div style="display:flex ; justify-content:space-evenly;">
    <button
      class="edit-button"
      on:click={() => {
        const cb = navigator.clipboard;
        // const paragraph = document.querySelector("p");
        cb.writeText(gradientStyle).then(() => alert("Style copied"));
      }}>Copy Style</button
    >
    <CustomizerModal codeText={gradientStyle} />
    <GradientPreviewModal codeText={gradientStyle} />
  </div>
</div>

<style>
  div.gradient-container {
    display: flex;
    flex-direction: column;
    width: 360px;
    height: 260px;
    border: 1px solid gray;
    margin: 3px;
  }
  .bg-gradient {
    width: 100%;
    height: 100%;
    /* margin: 12px 6px; */
  }
  .gradient-style-text {
    font-size: 12px;
    /* text-align: center; */
    border-top: 3px ridge rgb(165, 161, 161);
    padding: 6;
    margin: 0;
    color: #fff;
    background-color: #000;
  }
  .edit-button {
    border: 1px outset grey;
    border-radius: 20px;
    background-color: azure;
    margin: 6px auto;
    box-shadow: 2px 2px 4x rgba(24, 24, 24, 0.8);
  }
</style>
